import { createAsyncThunk } from '@reduxjs/toolkit';
import { Article } from '@wix/answers-api';

import { fedopsLogger } from '../../util/renderModel';
import { getArticleById } from '../api/getArticleById';
import { getArticleByUri } from '../api/getArticleByUri';
import { HttpClientFactory } from '../httpClient';
import { TRootState } from '../reducers';
import { ErrorStatus } from '../reducers/types';

export const loadArticleById = createAsyncThunk<
  Article,
  { id: string; httpClient: HttpClientFactory },
  { state: TRootState; rejectValue: ErrorStatus }
>('loadArticleById', async ({ id, httpClient }, { rejectWithValue }) => {
  try {
    fedopsLogger.interactionStarted('fetching-article');
    return await getArticleById(id, httpClient);
  } catch (error) {
    return rejectWithValue(error.response?.status);
  } finally {
    fedopsLogger.interactionEnded('fetching-article');
  }
});

export const loadArticleByUri = createAsyncThunk<
  Article,
  { uri: string; httpClient: HttpClientFactory },
  { state: TRootState; rejectValue: ErrorStatus }
>('loadArticleByUri', async ({ uri, httpClient }, { rejectWithValue }) => {
  try {
    fedopsLogger.interactionStarted('fetching-article');
    return await getArticleByUri(uri, httpClient);
  } catch (error) {
    return rejectWithValue(error.response?.status);
  } finally {
    fedopsLogger.interactionEnded('fetching-article');
  }
});
